<template>
  <section class="cars-nav-mobile" :class="[nav_class, { fixed: fixed }]">
    <div class="container">
      <ul class="cars-nav-mobile__list">
        <li
          v-for="(item, index) in nav_list"
          :key="index"
          class="cars-nav-mobile__item"
          :class="{ active: item.active }"
          @click="changeFilter(item)"
        >
          {{ item.name }}
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import Mixin from "../common/mixin";
import smoothScrollTo from "../common/smoothScrollTo";
import $ from "jquery";

export default {
  name: "cars-nav-mobile",
  props: ["nav_list", "nav_class"],
  mixins: [Mixin],
  data() {
    return {
      fixed: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", () => {
      const blockCarsElem = document.querySelector(".block-cars");
      if (
        window.pageYOffset >= blockCarsElem.offsetTop &&
        window.pageYOffset <
          blockCarsElem.offsetHeight + blockCarsElem.offsetTop - 200
      ) {
        this.fixed = true;
        this.$emit("change-position", this.fixed);
      } else {
        this.fixed = false;
        this.$emit("change-position", this.fixed);
      }
    });
  },
  methods: {
    scrollTo(where) {
      let offset = this.device_platform === "desktop" ? 110 : 160;
      smoothScrollTo($("#" + where).offset().top - offset);
    },
    changeFilter(value) {
      this.$emit("change", value);

      this.$nextTick(() => {
        this.scrollTo("cars");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/constants.scss";

.cars-nav-mobile {
  position: relative;

  &.fixed {
    position: fixed;
    top: 66px;
    bottom: 0;
    z-index: 10;
    height: 77px;
    width: 100%;
    max-width: 1180px;
    background-color: #fff;
  }

  &__list {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    list-style: none;
    border-bottom: 2px solid #b3b3b3;
  }

  &__item {
    width: 100%;
    max-width: 90px;
    padding: 0 5px;
    margin-bottom: 10px;
    font-size: 12px;
    color: $gray_dark;
    font-weight: bold;
    font-family: "AudiTypeExt", sans-serif;
    white-space: nowrap;
    position: relative;
    text-align: center;
    cursor: pointer;

    &:hover {
      color: $red;
    }

    &.active {
      color: $red;
    }
  }
}

@media (max-width: 580px) {
  .cars-nav-mobile {
    &.fixed {
      height: 100px;
    }
  }
}

@media (max-width: 500px) {
  .cars-nav-mobile {
    .container {
      padding: 10px 0;
    }

    &__list {
      align-items: flex-start;
    }
    &__item {
      max-width: 60px;
      padding: 0 3px;
      margin-bottom: 10px;
      font-size: 9px;
      white-space: unset;
    }
  }
}

@media (max-width: 320px) {
  .cars-nav-mobile {
    &.fixed {
      height: 70px;
    }

    &__item {
      max-width: 53px;
      margin-bottom: 5px;
      font-size: 7px;
    }
  }
}
</style>
